export const ru = {
    'set-context-price': 'Максимальная ставка за тыс. показов для новых и измененных условий показа'
};
